import {TypeUtils} from "../../../../../shared/utils/type-utils";

export class Record {
  public status: string;
  public name: string;
  public value: string;
  public type: string;

  constructor(data, hostname) {
    this.status = Record.setStatus(data);
    this.value = data.txt_value || data.value || (!TypeUtils.isEmpty(data) ? data : '');
    this.name = data.txt_name || data.name ? Record._modifyValue(data.txt_name || data.name, hostname) : "@";
    this.type = data.type;
  }

  private static _modifyValue(record: string, hostname: string): string {
    const sslVerfRecord = record.split(hostname);
    return sslVerfRecord && sslVerfRecord[0] && sslVerfRecord[0].replace(/\.$/, "") || "@";
  }

  private static setStatus(data: any): string | null {
    return data.status || data.type || null;
  }
}
